class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add("animate", "active");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.notification.classList.remove("active");
    document.body.removeEventListener("click", this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    if (parsedState.key) {
      this.cartItemKey = parsedState.key;
    } else {
      let item_key_index = parsedState.items.length - 1;
      this.cartItemKey = parsedState.items[item_key_index].key;
    }

    this.getSectionsToRender().forEach((section) => {      
      if (section) {
        let sectionElement = document.getElementById(section.id);
        if (sectionElement) {
          // Only update if the element exists
          sectionElement.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
        } else {
          console.warn(`Element with ID '${section.id}' not found.`);
        }
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  /*getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }*/

  getSectionInnerHTML(html, selector = ".shopify-section") {
    let parsedDoc = new DOMParser().parseFromString(html, "text/html");
    let sectionElement = parsedDoc.querySelector(selector);
    // console.log(sectionElement, selector);

    if (sectionElement) {
        if (
        window.aico_percentage_discount &&
        window.aico_percentage_discount != 0
      ) {
        let priceValueNew = 0;
        let checkComparePrice = sectionElement.querySelector(
          ".cart-notification-price"
        );

        if (checkComparePrice) {
          var comparePriceAttr =
            checkComparePrice.getAttribute("data_compare_price");
            console.log('comparePriceAttr11',comparePriceAttr)
        } else {
          console.log("checkComparePrice element not found");
        }

        let priceElement = sectionElement.querySelector(
          ".cart-notification-price .product-option"
        );
        let priceElementTrikot = sectionElement.querySelector(
          ".cart-notification-price .price"
        );
        const oldPriceElements = document.querySelectorAll('.cart-item__old-price');
          oldPriceElements.forEach(element => element.remove());
        if (priceElementTrikot) {
          priceElement = priceElementTrikot;
        }
    console.log('priceElement',priceElement)

        if (priceElement) {
          let priceText = priceElement.textContent.trim();
          let priceValue = parseFloat(
            priceText.replace(/[^\d,.]/g, "").replace(",", ".")
          );
          console.log("Price value as float:", priceValue);

          let discountedPrice;
          let originalPrice = priceText; // Price to show as strikethrough
          
          // If compare_at_price exists, calculate discount from compare_at_price
          if(comparePriceAttr) {
            let comparePriceValue = comparePriceAttr / 100;
            console.log('Using compare_at_price for discount:', comparePriceValue);
            let compareDiscountPrice = applyAicoDiscount(comparePriceValue);
            
            // Give customer the maximum discount - use the lower of the two prices
            if (compareDiscountPrice < priceValue) {
              // Discounted price is better for customer
              console.log('Using discounted price (better for customer):', compareDiscountPrice);
              discountedPrice = compareDiscountPrice;
              originalPrice = `CHF ${comparePriceValue.toFixed(2)}`; // Show compare_at_price as strikethrough
            } else {
              // Current price is better for customer
              console.log('Using current price (better for customer):', priceValue);
              discountedPrice = priceValue.toFixed(2);
              originalPrice = `CHF ${comparePriceValue.toFixed(2)}`; // Show compare_at_price as strikethrough
            }
          } else {
            // No compare_at_price, calculate discount from current price
            console.log('Using current price for discount:', priceValue);
            discountedPrice = applyAicoDiscount(priceValue);
            originalPrice = priceText; // Show current price as strikethrough
          }

          if (priceValueNew) {
            let discountedPriceNew = (
              parseFloat(discountedPrice) + parseFloat(priceValueNew)
            ).toFixed(2);
            discountedPrice = discountedPriceNew;
            console.log("discountedPriceNew", discountedPriceNew);
          }
          console.log('Original price for strikethrough:', originalPrice);
          // let parsedDoc = new DOMParser().parseFromString(html, 'text/html');
          let strikePriceElement = parsedDoc.querySelector('.cart-notification-price .af-strike-price');
          console.log('strikePriceElement',strikePriceElement);
          if (strikePriceElement) {
            strikePriceElement.innerHTML = originalPrice;
          } else {
            console.log(".af-strike-price element not found.");
          }
          console.log('cart-notification');
          
          priceElement.innerHTML = `<span class="af-discount-price"><span class="af-discount-text">DEIN PREIS:</span><span class="af-discount-price-inner">CHF ${formatCHF(discountedPrice)}</span></span>`;
          //priceElement.classList.add("af-discount-price");

        } else {
          console.warn(".product-option price element not found in section");
        }
      }
      this.processCartRelatedProducts();
        return sectionElement.innerHTML;
    } else {
        console.warn(`Selector '${selector}' not found in parsed HTML.`);
        return ''; // Return an empty string to prevent errors
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  processCartRelatedProducts() {
  // const relatedProducts = $('.aico-product-search-list li');
    const relatedProducts = $('.cart-notification-product .connected_products_wrapper li').not('[data-processed="true"]');

  if (relatedProducts.length) {
    relatedProducts.each(function() {
      const li = $(this);
      const span = li.find('span#aico-price-list');

      if (span.length) {
        const dataAttr = span.attr('data-aico_price_object');

        if (dataAttr) {
          try {
            const dataObj = JSON.parse(dataAttr);

            // const entry = {};
            // entry[dataObj.handle] = {
            //   vendor: dataObj.vendor,
            //   aico_product_collections: dataObj.aico_product_collections || "all",
            //   price: dataObj.price,
            //   compare_price: dataObj.compare_price
            // };

            if(window.aico_percentage_discount && window.aico_percentage_discount!=0){
                // Calculate discount from compare_at_price if available, otherwise from current price
                let amount = 0;
                let originalPrice;
                
                if(dataObj.compare_price) {
                  // Calculate discount from compare_at_price
                  // card JSON prices are already in CHF ("29.00"), not cents
                  let comparePriceValue = parseFloat(dataObj.compare_price);
                  let compareDiscountPrice = applyAicoDiscount(comparePriceValue);
                  let currentPriceValue = parseFloat(dataObj.price);
                  
                  // Give customer maximum discount - use the lower price
                  if(compareDiscountPrice < currentPriceValue) {
                    // Discounted price is better for customer
                    amount = compareDiscountPrice;
                    originalPrice = `CHF ${comparePriceValue.toFixed(2)}`;
                  } else {
                    // Current price is better for customer
                    amount = currentPriceValue;
                    originalPrice = `CHF ${comparePriceValue.toFixed(2)}`;
                  }
                } else {
                  // No compare_at_price, calculate discount from current price
                  amount = applyAicoDiscount(dataObj.price);
                  originalPrice = `CHF ${parseFloat(dataObj.price).toFixed(2)}`;
                }
                
                li.find('.af-strike-price').html(originalPrice);
                console.log('cart-notification 1');
                li.find('.af-price').html(`<span class="af-discount-text">DEIN PREIS:</span><span class="af-discount-price-inner">CHF ${formatCHF(amount)}</span>`).addClass('af-discount-price');
                li.find('.card_options_form form #price_item_discount').remove();
                li.find('.card_options_form form ').append(`<input id="price_item_discount" type="hidden" name="properties[_price_item_discount]" value="${amount}">`)
                li.attr('data-processed', 'true');
              }
          } catch (e) {
            console.error('Invalid JSON in data-aico_price_object', e);
          }
        }
      }
    });

    // console.log('Final structured data:', aico.aico_price_list_products);
    return true; // Indicate that processing was successful
  } else {
    // console.log('No related products found.');
    return false; // Indicate that processing was not done yet
  }
}
}

customElements.define("cart-notification", CartNotification);
